// Loaded theme set + active theme. Owned by app/theme.

import { THEME_DEFAULTS } from '../../config/defaults';
import type { ThemeDefaults } from '../../config/defaults';

export interface ThemeState {
    current: ThemeDefaults | null;
    // name → theme-config URL. Populated by app/sceneIO.loadThemesFromScene
    // from the scene.json `themes` array. The active theme's parsed contents
    // live on `current`, not here.
    options: Record<string, string>;
}

export function createThemeState(): ThemeState {
    return {
        current: { ...THEME_DEFAULTS, ui: { ...THEME_DEFAULTS.ui }, scene: { ...THEME_DEFAULTS.scene, grid: { ...THEME_DEFAULTS.scene.grid } } },
        options: {},
    };
}
